@if ((positions | async)?.length === 0) {
  <div>
    <app-empty
      (buttonClick)="createPosition()"
      message="Mit Positionen gibst du deinem Projekt Struktur. Positionen sind einzelne Arbeitspakete um deine Stunden zu erfassen."
    ></app-empty>
  </div>
} @else {
  <div class="w-full flex justify-end gap-4">
    <button appTailwindButton color="white" disabled>
      Offerte generieren <app-badge class="ml-2" color="green">Coming Soon</app-badge>
    </button>
    <button appTailwindButton color="secondary" (click)="createPosition()">Neue Position</button>
  </div>
  <div class="pt-4 flex flex-col md:flex-row-reverse gap-4">
    <div class="flex flex-col gap-4 w-full">
      @for (position of positions | async; track position.id) {
        <app-position-card
          [position]="position"
          [userId]="(userId | async) ?? null"
          (createWork)="createWork(position)"
          (modifyPosition)="modifyPosition(position)"
          (showWork)="showWork(position)"
          (favoriteChanged)="positionFavoriteChanged(position, $event)"
        >
        </app-position-card>
      }
    </div>
  </div>
}
